import React, { useState, useEffect } from "react";
import teamIcon from "../../assets/icons/mangment icons/team.png";
import titleIcon from "../../assets/icons/mangment icons/title.png";
import permissionGroupIcon from "../../assets/icons/mangment icons/PermissionGroup.png";
import adminIcon from "../../assets/icons/mangment icons/admin.png";
import { deleteDataToken, getData } from "../../axios/axiosHelper";
import { toast } from "react-toastify";
import { toastMsg } from "../../functions/toastMsg";
import { ADMIN_PAGE_LABELS } from "../../navigation/adminNavigation";

const PermissionGroupHooks = () => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [permissionGroup, setPermissionGroup] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const perPage = 10;
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [search, setSearch] = useState(false);

  const NavItems = [
    {
      name: ADMIN_PAGE_LABELS.roles,
      to: "/management/permissiongroup",
      icon: permissionGroupIcon,
    },
    {
      name: ADMIN_PAGE_LABELS.admins,
      to: "/management/admins",
      icon: adminIcon,
    },
  ];
  useEffect(() => {
    setLoading(true);
    let queryParams = `/permissionGroup?page=${currentPage}&perPage=${perPage}`;

    if (search) {
      queryParams += `&search=${encodeURIComponent(search)}`;
    }

    getData(queryParams, true)
      .then((res) => {
        setPermissionGroup(res.data.data);
        setTotalPages(res.data.pagination.totalPages);
      })
      .catch((err) => toastMsg(err.response.data.message, "error"))
      .finally(() => setLoading(false));
  }, [currentPage, perPage, search]);
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  const formatLabel = (label) => {
    return label
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/^./, (str) => str.toUpperCase());
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const onSubmitdelete = (id) => {
    setLoading(true);
    deleteDataToken(`/permissionGroup/${id}`, true)
      .then((res) => {
        toastMsg(res.data?.message, "success");
        setPermissionGroup((prev) =>prev.filter((pr) => pr._id !== id));
      })
      .catch((err) => toastMsg(err.response.data?.message))
      .finally(() => setLoading(false));
  };
  return {
    NavItems,
    setSearch,
    handleShow,
    show,
    handleClose,
    loading,
    permissionGroup,
    handleNextPage,
    handlePrevPage,
    totalPages,
    currentPage,
    formatLabel,
    formatDate,
    onSubmitdelete
  };
};

export default PermissionGroupHooks;
